import React from 'react'
import styled from 'styled-components'

const LegendItem = styled.div`
  display: inline-block;
  font-weight: 600;
  margin-right: 1.5em;
`
const Square = styled.div`
  width: 12px;
  height: 12px;
  float: left;
  margin-right: .5em;
  margin-top: 4px;
`

const LineLegend = ({ items }) => items.map((item, i) => (
  <LegendItem key={i}>
    {item.label}
    <Square style={{backgroundColor: item.color}} />
  </LegendItem>
))

export default LineLegend



// WEBPACK FOOTER //
// ./src/components/UI/Chart/LineLegend.jsx